import { BackendResponse } from "../BackendResponse";
import { withNextApi } from "../nextApiHelpers";
import { KommunerFullRow } from "../_SharedTypes/KommunerFullRow";

export interface GetMunicipalitiesResponse extends BackendResponse {
  items: KommunerFullRow[];
}

export const getMunicipalities = withNextApi<GetMunicipalitiesResponse>(
  "/cvp/CvpGetMunicipalities"
);
